import Logo from "@assets/icons/voxtox_alt.svg";
import Button from "@components/Button";
import FadedText from "@components/FadedText";
import { AltText, Column, Row } from "@components/Layout";
import { Template } from "@components/Template";
import useI18n from "@contexts/I18nProvider/hooks/useI18n";
import { Image } from "@kobalte/core";
import { playerContext } from "@layouts/App/context/Player";
import PlayButton from "@layouts/App/context/Player/components/PlayButton";
import usePlay from "@layouts/App/context/Player/hooks/usePlay";
import { useNavigate } from "@solidjs/router";
import { formatPostTotalTime } from "@src/app/utils";
import { BsDot } from "solid-icons/bs";
import { FaSolidHeadphones, FaSolidShare } from "solid-icons/fa";
import { Show, type VoidComponent, useContext } from "solid-js";
import { MobileHeaderColumn, MobilePlayButton, SignInButton, TracklistImage } from "./styled";
import type { MobileHeaderProps } from "./types";

const MobileHeader: VoidComponent<MobileHeaderProps> = (props) => {
	const { player } = useContext(playerContext);
	const { playTracklist } = usePlay();
	const navigate = useNavigate();
	const { t } = useI18n();

	return (
		<MobileHeaderColumn alignItems="center" gap="20px" padding="15px 0">
			<TracklistImage onclick={props.onImageClick}>
				<Image.Img src={props.tracklist.photo} />
				<Image.Fallback>
					<Template w="100%" h="100%" />
				</Image.Fallback>
			</TracklistImage>
			<Column alignItems="center" gap="5px">
				<h4 style={{ "text-align": "center" }}>{props.tracklist.name}</h4>
				<FadedText fontSize="12px">{props.tracklist.author.nickname}</FadedText>
			</Column>
			<Row justifyContent="center" alignItems="center" gap="10px">
				<Column w="32px" />
				<MobilePlayButton>
					<PlayButton
						diameter="25px"
						alt
						onClick={() => playTracklist(props.tracklist, 0)}
						tracklistUuid={props.tracklist.uuid}
						class="altPlayer"
						text={
							player.playing && player.queue[player.track]?.tracklistUuid === props.tracklist.uuid
								? t("app.programme.pause")
								: t("app.programme.play")
						}
					/>
				</MobilePlayButton>
				<Button borderRadius="50%" diameter="32px" onclick={props.onShare}>
					<FaSolidShare />
				</Button>
			</Row>
			<Show when={props.public}>
				<SignInButton
					onclick={() =>
						navigate("/landing/*", {
							state: {
								login: true,
							},
						})
					}
				>
					<img src={Logo} alt="logo" />
					{t("app.programme.signIn")}
				</SignInButton>
			</Show>
			<Row justifyContent="center" alignItems="center" gap="5px">
				<FadedText fontSize="12px" lineHeight={0}>
					<FaSolidHeadphones />
				</FadedText>
				<FadedText fontSize="12px">
					{formatPostTotalTime(props.tracklist.tracks.reduce((p, c) => p + c.length, 0))}
				</FadedText>
				<AltText lineHeight={0}>
					<BsDot />
				</AltText>
				<FadedText fontSize="12px">{t("app.programme.tracks", props.tracklist.tracks.length)}</FadedText>
			</Row>
		</MobileHeaderColumn>
	);
};
export default MobileHeader;
